import { validation } from '@/util/validation.js';
export default {
  submitText: '保存',
  emptyBtn: false,
  column: [
    {
      label: 'id',
      display: false,
      prop: 'id',
    },
    {
      label: '车场名称',
      type: 'tree',
      prop: 'spaceId',
      editDisabled: true,
      disabled: true,
      search: true,
      cell: true,
      props: {
        label: 'title',
        value: 'key',
      },
      dicUrl: '/api/v4ward/car/parkSpaceNode/treeChildrenCarParkNode?id=0',
    },
    {
      label: '车牌号',
      disabled: true,
      prop: 'carNo',
    },
    {
      label: '区域',
      prop: 'regionsName',
      disabled: true,
    },
    {
      label: '收费标准',
      prop: 'ruleName',
      disabled: true,
    },
    {
      label: '车主姓名',
      search: true,
      prop: 'customerName',
      disabled: true,
      rules: [
        {
          message: '请输入客户姓名',
          trigger: 'change',
        },
      ],
    },
    {
      label: '手机号',
      prop: 'customerPhone',
      disabled: true,
      search: true,
    },
    {
      label: '操作',
      prop: 'operateType',
      display: false,
    },
    {
      label: '新车牌号',
      prop: 'newCarNo',
      formslot: true,
      filterable:false,
      rules: [
        {
          required: true,
          message: '请选择车牌号',
          trigger: 'change',
        },
        {
          pattern: validation.carPlate,
          message: '车牌号格式错误',
          trigger: 'blur',
        },
      ],
    },
  ],
};
